export function customForm() {
    let $who_are_you = $("input[name=who-are-you]");
    let value = $('.custom-form').attr('data-who-are-you');

    if ($who_are_you.length && value !== '') {
        $("input[name=who-are-you][value=" + value + "]").prop("checked", true);
    }

    if ($('body').hasClass("single-test")) {
        let selectTests = $('#tests');
        let hiddenTest = $('#name-test');

        let $popupForms = $('#requisition-form, #popup-download-test');

        let test = $popupForms.attr('data-test');

        if (selectTests.length && test !== '') {
            selectTests.find('option[value="' + test + '"]').attr('selected', 'selected');
            jcf.replaceAll();

            hiddenTest.val(test);
        }
    }

    document.addEventListener('wpcf7submit', function (event) {
        let inputs = event.detail.inputs;
        let formData = {};


        for (let i = 0; i < inputs.length; i++) {
            if ($.inArray(inputs[i].name, ['who-are-you', 'firstname', 'lastname', 'phone', 'email', 'job']) >= 0) {
                formData[inputs[i].name] = inputs[i].value;
            }
        }

        let expiry = new Date();
        expiry.setTime(expiry.getTime() + 30 * 24 * 60 * 60 * 1000);
        document.cookie = "formData=" + JSON.stringify(formData) + "; path=/; expires=" + expiry.toGMTString();
    }, false);

    function getCookieValue(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let getFormData = getCookieValue("formData");

    let $forms = $('form');

    if ($forms.length && getFormData) {
        let parseFormData = JSON.parse(getFormData);

        $forms.each(function () {
            let $this = $(this);
            for (const [key, value] of Object.entries(parseFormData)) {
                if (key == 'who-are-you') {
                    $this.find("input[name='" + key + "'][value='" + value + "']").prop('checked', true);
                } else {
                    if ($this.find("[name='" + key + "']")) {
                        $this.find("[name='" + key + "']").val(value);
                    }
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customForm.js